class slickTsBannerJs{

    constructor(
        elementBannerSlick
    ) {
        this.elementBannerSlick = elementBannerSlick;
    }

    bindEvents() {
        this.elementBannerSlick.not('.slick-initialized').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }
}
document.addEventListener('DOMContentLoaded', () => {
    if (typeof $('.banners') != "undefined" && $('.banners').length > 0) {
        let v = new slickTsBannerJs(
            $('.banners')
        );
        v.bindEvents();
    }
});